<template>
  <div
    v-if="product"
    :class="[textColorClass, textClass, {'grey--text lighten-1': disabled}]"
    :style="outlined ? `border: var(--v-${borderColorClass}-base) 1px solid; min-width: 40px; min-height: 40px; border-radius: 4px;` : 'min-width: 26px;'"
    class="d-inline-flex"
  >
    <template v-if="product.UnitId > 1">
      {{ formatUnitQuantity($i18n.locale, product.UnitQuantity, getMeasurementUnitById(product.UnitId)) }}
    </template>
    <template v-else>
      <template v-if="!hideMultiplySymbol">
        {{ product.Quantity }}x
      </template>
      <template v-else>
        {{ product.Quantity }}
      </template>
    </template>
  </div>
</template>
<script>

import ProductQuantityMixin from '@/theme/default/components/product/ProductQuantity.js'

export default {
  name  : 'ProductQuantity',
  mixins: [ProductQuantityMixin],
  props : {
    textClass: {
      type   : String,
      default: 'text-center align-center justify-center'
    },

    textColorClass: {
      type   : String,
      default: 'brand-green-dark--text'
    }
  }
}
</script>

<style scoped src="@/theme/default/components/product/ProductQuantity.css"></style>

<style scoped>
</style>
